import React from "react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixOrderInfoProps } from "../types";

const PixOrderInfo: React.FC<PixOrderInfoProps> = ({
  orderNumber,
  orderStatus,
  customerName,
  productCode,
  productName,
  volume,
  deliveryDate,
  paymentStatus,
}) => {
  const classes = usePixModalStyles();
  const isPending = paymentStatus === "pending";
  const isBlocked = orderStatus === "BLOQUEADO";

  return (
    <div
      className={`${classes.orderCard} ${
        !isPending ? classes.orderCardConfirmed : ""
      }`}
    >
      <div className={classes.orderCardTop}>
        <div className={classes.orderNumber}>
          Pedido #{orderNumber}
          <span
            className={`${classes.orderStatusBadge} ${
              isBlocked
                ? classes.orderStatusBlocked
                : classes.orderStatusReleased
            }`}
          >
            {orderStatus}
          </span>
        </div>
        <div className={classes.orderDelivery}>
          Entrega{" "}
          <span className={classes.orderDeliveryValue}>{deliveryDate}</span>
        </div>
      </div>

      <div className={classes.orderDetailRow}>
        <span className={classes.orderDetailLabel}>Cliente</span>
        <span className={classes.orderDetailValue}>{customerName}</span>
      </div>
      <div className={classes.orderDetailRow}>
        <span className={classes.orderDetailLabel}>Produto</span>
        <span className={classes.orderDetailValue}>
          {productCode} · {productName}
        </span>
      </div>
      <div className={classes.orderDetailRow}>
        <span className={classes.orderDetailLabel}>Quantidade</span>
        <span
          className={`${classes.orderDetailValue} ${classes.orderDetailValueStrong}`}
        >
          {volume}
        </span>
      </div>
    </div>
  );
};

export default PixOrderInfo;
